export default "__VITE_ASSET__17041803__"